import { render } from "./SearchHeaderWidget.vue?vue&type=template&id=020d5822&scoped=true"
import script from "./SearchHeaderWidget.vue?vue&type=script&lang=js"
export * from "./SearchHeaderWidget.vue?vue&type=script&lang=js"

import "./SearchHeaderWidget.vue?vue&type=style&index=0&id=020d5822&scoped=true&lang=css"

import exportComponent from "d:\\OSPanel\\domains\\health\\health-ks-shop\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020d5822"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QSkeleton,QBanner});
